// react
import * as React from 'react';
import { Grid } from 'svg-loaders-react'

export default function Loading() {
  return (
    <div className="loading">
      <Grid />
    </div>
  );
}
